export default function NotesPage() {
    return (
      <div>
        <h1 className="text-2xl font-bold mb-4">Case Notes</h1>
        <p>Internal case notes will be managed here.</p>
      </div>
    );
  }